import { Component, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { PortMultieComponent, AgOverlayTemplate, AgEvent, AgAutoCompleteItem, MultiSelectItem, MultiSelectorComponent } from "../../components";
import { GridFareTransConfig } from "./fare-management-grid-trans";
import { AgGridNg2 } from "ag-grid-angular";
import { GridApi, ColumnApi, CellValueChangedEvent, GridOptions, IGetRowsParams } from "ag-grid";
import { Subscription } from "rxjs";
import { FareService, GridTransRouteFare, CallBack, RouteFareTrans, Port, CrncyRateModel, Line, AirLine, PortService, OceanLineService, AirLineService, CurrencyService, AirPortService, AlertService, TransFareConditionModel, TransType, Country, UserService, FareCorp, CostItemService, CostItemModel, IncidFareConditionModel, RouteFareIncidReq, RouteFareIncidReqGrp, GridIncidRouteFare, RouteFareIncid } from "../../services";
import { GridFareIncidConfig } from "./fare-management-grid-incid";
import { ComponentSource } from "ag-grid/dist/lib/components/framework/componentResolver";

@Component({
  selector: 'fare-management',
  templateUrl: 'fare-management.html'
})
export class FareManagement implements OnInit {
  
  private transTp: number;
  private crgoTp: number;
  private myCorp: FareCorp;

  private gridTransConfig = new GridFareTransConfig(this);
  private gridIncidConfig = new GridFareIncidConfig(this);

  private get transType() {
    if (this.transTp == 0 && this.crgoTp == 0) return TransType.FCL;
    if (this.transTp == 0 && this.crgoTp == 1) return TransType.LCL;
    if (this.transTp == 1 && this.crgoTp == 1) return TransType.AIR;
    else return null;
  }

  private gridTransFareList: Array<GridTransRouteFare> = [];
  private gridIncidFareList: Array<GridIncidRouteFare> = [];
  private gridIncidFareReqList: Array<RouteFareIncidReqGrp> = [];
  private gridIncidFareReqDtlList: Array<RouteFareIncidReq> = [];

  @ViewChild('orgPortSelector') private orgPortSelector: PortMultieComponent;
  @ViewChild('desPortSelector') private desPortSelector: PortMultieComponent;
  @ViewChild('lineSelector') private lineSelector: MultiSelectorComponent;

  @ViewChild('portSelector') private portSelector: PortMultieComponent;
  @ViewChild('costItemSelector') private costItemSelector: MultiSelectorComponent;

  @ViewChild('gridTrans') gridTrans: AgGridNg2;
  gridTransApi: GridApi;
  gridTransColumnApi: ColumnApi;
  gridTransParams;

  @ViewChild('gridIncid') gridIncid: AgGridNg2;
  gridIncidApi: GridApi;
  gridIncidColumnApi: ColumnApi;

  @ViewChild('gridIncidReq') gridIncidReq: AgGridNg2;
  gridIncidReqApi: GridApi;
  gridIncidReqColumnApi: ColumnApi;
  gridIncidReqParams;
  
  lines: Line[] = [];
  ports: Port[] = [];
  costItems: CostItemModel[] = [];
  portAutoCompleteItemList: AgAutoCompleteItem[] = [];
  currencyAutoCompleteItemList: AgAutoCompleteItem[] = [];
  lineAutoCompleteItemList: AgAutoCompleteItem[] = [];
  lineMultiSelectItems: MultiSelectItem[] = [];
  costItemAutoCompleteItemList: AgAutoCompleteItem[] = [];
  costItemMultieSelectItems: MultiSelectItem[] = [];
  
  getTransFareSubs: Subscription;
  getTransIncidSubs: Subscription;
  getTransIncidReqSubs: Subscription;

  rowBuffer;
  rowModelType: string;
  paginationPageSize: number;
  cacheOverflowSize;
  maxConcurrentDatasourceRequests;
  infiniteInitialRowCount;
  maxBlocksInCache;
  rowData: any[];
  blockSize: number = 200;
  inciReqBlockSize: number = 20;

  transReqBody:TransFareConditionModel = new TransFareConditionModel();
  incidReqReqBody:IncidFareConditionModel = new IncidFareConditionModel();

  private get transColumnDefs() {
    if (this.transType == TransType.FCL) return this.gridTransConfig.colDefFclTrans;
    else if (this.transType == TransType.LCL) return this.gridTransConfig.colDefLclTrans;
    else if (this.transType == TransType.AIR) return this.gridTransConfig.colDefAirTrans;
    else return null;
    
  }
  
  private get frameworkCompsTrans() {
    if (this.transType == TransType.FCL) return this.gridTransConfig.frameworkCompsFclTrans;
    else if (this.transType == TransType.LCL) return this.gridTransConfig.frameworkCompsLclTrans;
    else if (this.transType == TransType.AIR) return this.gridTransConfig.frameworkCompsAirTrans;
    else return null;    
  }


  private get incidColumnDefs() {
    if (this.transType == TransType.FCL) return this.gridIncidConfig.colDefFclIncid;
    else if (this.transType == TransType.LCL) return this.gridIncidConfig.colDefLclIncid;
    else if (this.transType == TransType.AIR) return this.gridIncidConfig.colDefAirIncid;
    else return null;
  }

  private get frameworkCompsIncid() {
    if (this.transType == TransType.FCL) return this.gridIncidConfig.frameworkCompsFclIncid;
    else if (this.transType == TransType.LCL) return this.gridIncidConfig.frameworkCompsLclIncid;
    else if (this.transType == TransType.AIR) return this.gridIncidConfig.frameworkCompsAirIncid;
    else return null;
  }

  private colDefFareReq = this.gridIncidConfig.colDefFareReq;

  private get colDefFareReqDtl() {
    if (this.transType == TransType.FCL) return this.gridIncidConfig.colDefFareReqDtlFcl;
    else if (this.transType == TransType.LCL) return this.gridIncidConfig.colDefFareReqDtlLcl;
    else if (this.transType == TransType.AIR) return this.gridIncidConfig.colDefFareReqDtlAir;
    else return null;
  }

  private get transContextMenuItems() {
    let spliceCallBack: (row: number) => void = (row: number) => {
      let transFare: GridTransRouteFare = new GridTransRouteFare();
      transFare.init(null, null, this.transType, this.myCorp, 'DIRECT');
      this.gridTransFareList.splice(row, 0, transFare);
      this.gridTransApi.setRowData(this.gridTransFareList);
    };
    let pushCallBack: () => void = () => {
      let transFare: GridTransRouteFare = new GridTransRouteFare();
      transFare.init(null, null, this.transType, this.myCorp, 'DIRECT');
      this.gridTransFareList.push(transFare);
      this.gridTransApi.setRowData(this.gridTransFareList);
    }

    return this.fareService.getContextMenuItems(spliceCallBack, pushCallBack);
  }

  private get incidContextMenuItems() {
    let spliceCallBack: (row: number) => void = (row: number) => {
      let transIncid: GridIncidRouteFare = new GridIncidRouteFare();
      transIncid.init(null, this.transType, this.myCorp, null);
      this.gridIncidFareList.splice(row, 0, transIncid);
      this.gridIncidApi.setRowData(this.gridIncidFareList);
    };
    let pushCallBack: () => void = () => {
      let transIncid: GridIncidRouteFare = new GridIncidRouteFare();
      transIncid.init(null, this.transType, this.myCorp, null);
      this.gridIncidFareList.push(transIncid);
      this.gridIncidApi.setRowData(this.gridIncidFareList);
    }

    return this.fareService.getContextMenuItems(spliceCallBack, pushCallBack);
  }

  rowClassRules = {"deleted-row": (params) => params.data && params.data.isDel};
  overlayLoadingTemplate = AgOverlayTemplate.overlayProcessingTemplate;
  onGridKeyDown = AgEvent.onDelKeyDown;
  
  getPortItemListByCntry(cntry: Country): AgAutoCompleteItem[] {
    if (!cntry) return this.portAutoCompleteItemList;

    let cntryPortItemList = this.portAutoCompleteItemList.filter(
      item => {
        if (!item.data || !item.data.cntryCd ) return false;
        return item.data.cntryCd == cntry.cntryCd;
      }
    );

    return cntryPortItemList;
  }
  
  constructor(
    private route: ActivatedRoute,
    private fareService: FareService,
    private portService: PortService,
    private airportService: AirPortService,
    private oceanLineService: OceanLineService,
    private airLineService: AirLineService,
    private crncyService: CurrencyService,
    private alertService: AlertService,
    private costItemService: CostItemService
    ) {

    let session = JSON.parse(localStorage.getItem('currentUser'));
    this.myCorp = session.corporation;

    this.transTp = this.route.snapshot.data['transTp'];
    this.crgoTp = this.route.snapshot.data['crgoTp'];
    
    let ports = null;
    if (this.transTp == 0) ports = this.portService.ports;
    else ports = this.airportService.airports;
    if (!ports || ports.length <= 0) {
      if (this.transTp == 0) {
        this.portService.portListEe.subscribe(ports => this.initPortAutoCompleteItemList(ports));
      } else {
        this.airportService.airPortListEe.subscribe(airports => this.initPortAutoCompleteItemList(airports));
      }

    } else this.initPortAutoCompleteItemList(ports);
    
    let crncyList = this.crncyService.currencyList;
    if (!crncyList || crncyList.length <= 0) {
      this.crncyService.currencyListEe.subscribe(crncyList => this.initCurrencyAutoCompleteItemList(crncyList));
    } else this.initCurrencyAutoCompleteItemList(crncyList);
    

    let lines = null;
    if (this.transTp == 0) lines = this.oceanLineService.lineList;
    else lines = this.airLineService.lineList;
    if (!lines || lines.length <= 0) {
      if (this.transTp == 0) {
        this.oceanLineService.lineListEe.subscribe(lines => this.initOceanLineAutoCompleteItemList(lines));
      } else {
        this.airLineService.lineListEe.subscribe(lines => this.initAirLineAutoCompleteItemList(lines));
      }
    } else {
      if (this.transTp == 0) this.initOceanLineAutoCompleteItemList(lines);
      else this.initAirLineAutoCompleteItemList(lines);
    }

    let costItems = this.costItemService.costItemList;
    if (!costItems || costItems.length <= 0) {
      this.costItemService.costItemEe.subscribe(ci => this.initCostItemAutoCompleteItemList(ci));
    } else this.initCostItemAutoCompleteItemList(costItems);

    this.rowBuffer = 0;
    this.rowModelType = "infinite";
    this.paginationPageSize = 100;
    this.cacheOverflowSize = 2;
    this.maxConcurrentDatasourceRequests = 1;
    this.infiniteInitialRowCount = 200;
    this.maxBlocksInCache = 10;
  }
  
  ngOnInit() {
  }


  initPortAutoCompleteItemList (portList: Port[]) {
    this.ports = portList;
    this.portAutoCompleteItemList = portList.map((value:Port) => {
      let item = new AgAutoCompleteItem();
      item.value = '[' + value.portCd + '] ' + value.name;
      item.label = value.label;
      item.hiddenLabel = value.label + ' ' + value.labelKr;
      item.code = value.portCd;
      item.data = value;
      return item;
    })
  }

  initCurrencyAutoCompleteItemList(crncyList : CrncyRateModel[]) {
    this.currencyAutoCompleteItemList = crncyList.map<AgAutoCompleteItem>((value:CrncyRateModel) => {
      let item = new AgAutoCompleteItem();
      item.value = value.crncyCd;
      item.label = value.crncyCd;
      item.hiddenLabel = value.crncyCd;
      item.data = value;
      item.code = value.crncyCd;
      return item;
    });
  }

  initOceanLineAutoCompleteItemList(lines: Line[]) {
    this.lineAutoCompleteItemList = [];
    this.lines = lines;
    lines.forEach(line => {
      if (line.lineCd == 'ZZZ') return;
      
      let item: MultiSelectItem = new MultiSelectItem();
      item.value = line;
      item.label = line.lineCd;
      item.name = line.lineNm;
      item.isSelected = false;
      this.lineMultiSelectItems.push(item);

      let acItem: AgAutoCompleteItem = new AgAutoCompleteItem();
      acItem.value = '[' + line.lineCd + '] ' + line.lineNm;
      acItem.label = line.lineNm;
      acItem.hiddenLabel = line.lineCd;
      acItem.data = line;
      acItem.code = line.lineCd;
      this.lineAutoCompleteItemList.push(acItem);
    });
  }


  initAirLineAutoCompleteItemList(lines: AirLine[]) {
    this.lineAutoCompleteItemList = [];
    this.lines = [];
    lines.forEach(airport => {
      if (airport.lineCd == 'ZZZ') return;
      
      let line: Line = new Line();
      line.lineCd = airport.iataCd;
      line.lineNm = airport.name;
      this.lines.push(line);

      let item: MultiSelectItem = new MultiSelectItem();
      item.value = line;
      item.label = line.lineCd;
      item.name = line.lineNm;
      item.isSelected = false;
      this.lineMultiSelectItems.push(item);

      let acItem: AgAutoCompleteItem = new AgAutoCompleteItem();
      acItem.value = '[' + line.lineCd + '] ' + line.lineNm;
      acItem.label = line.lineNm;
      acItem.hiddenLabel = line.lineCd;
      acItem.data = line;
      acItem.code = line.lineCd;
      this.lineAutoCompleteItemList.push(acItem);
    });
  }

  initCostItemAutoCompleteItemList (costItems: CostItemModel[]) {
    let costItemMultieSelectItems: MultiSelectItem[] = [];
    let costItemAutoCompleteItemList: AgAutoCompleteItem[] = [];
    this.costItems = costItems;
    for (let costItem of costItems) {
      let item: MultiSelectItem = new MultiSelectItem();
      item.value = costItem;
      item.label = costItem.itemCd;
      item.name = costItem.itemNm;
      item.isSelected = false;
      costItemMultieSelectItems.push(item);
      
      let acItem: AgAutoCompleteItem = new AgAutoCompleteItem();
      acItem.value = '[' + costItem.itemCd + '] ' + costItem.itemNm;
      acItem.label = costItem.itemNm;
      acItem.hiddenLabel = costItem.itemCd;
      acItem.data = costItem;
      costItemAutoCompleteItemList.push(acItem);
    }
    this.costItemMultieSelectItems = costItemMultieSelectItems;
    this.costItemAutoCompleteItemList = costItemAutoCompleteItemList;
  }

  onGridTransReady(params) {
    this.gridTransApi = params.api;
    this.gridTransParams = params;
    this.gridTransColumnApi = params.columnApi;
  }

  onGridIncidReady(params) {
    this.gridIncidApi = params.api;
    this.gridIncidColumnApi = params.columnApi;
  }

  onGridIncidReqReady(params) {
    this.gridIncidReqApi = params.api;
    this.gridIncidReqColumnApi = params.columnApi;
    this.gridIncidReqParams = params;
  }

  onGridCellValueChange(event: CellValueChangedEvent) {
    event.data['isUpdate'] = true;
  }

  
  switchLocation() {
    this.orgPortSelector.switchValue(this.desPortSelector);
  }

  makeTransFareList() {
    let orgLocationList: Port[] = [];
    let desLocationList: Port[] = [];
    let lineList: Line[] = [];

    orgLocationList = this.orgPortSelector.selectedPortList;
    desLocationList = this.desPortSelector.selectedPortList;
    if (this.lineSelector) lineList = this.lineSelector.selectedValues.map<Line>(item => item.value);
    
    let appendList: GridTransRouteFare[] = [];
    orgLocationList.forEach(
      orgLocation => {
        desLocationList.forEach(
          desLocation => {
            if (lineList && lineList.length > 0) {
              lineList.forEach(
                line => {
                  let newFare: GridTransRouteFare = new GridTransRouteFare();
                  newFare.init(orgLocation, desLocation, this.transType, this.myCorp, 'DIRECT', line);
                  appendList.push(newFare);

                  if (this.transType == TransType.FCL) {
                    let newTsFare: GridTransRouteFare = new GridTransRouteFare();
                    newTsFare.init(orgLocation, desLocation, this.transType, this.myCorp, 'T/S', line);
                    appendList.push(newTsFare);
                  }
                }
              )
            } else {
              let newFare: GridTransRouteFare = new GridTransRouteFare();
              newFare.init(orgLocation, desLocation, this.transType, this.myCorp, 'DIRECT');
              appendList.push(newFare);

              if (this.transType == TransType.FCL) {
                let newTsFare: GridTransRouteFare = new GridTransRouteFare();
                newTsFare.init(orgLocation, desLocation, this.transType, this.myCorp, 'T/S');
                appendList.push(newTsFare);
              }
            }
          }
        )
      }
    );

    if (appendList && appendList.length > 0) this.gridTransFareList = this.gridTransFareList.concat(appendList);
  }

  getTransFareList(page, callback?: (resp) => void) {
    this.gridTransApi.showLoadingOverlay();

    this.transReqBody.curPage = page;
    if (this.orgPortSelector.selectedPortList) this.transReqBody.orgLocationList = this.orgPortSelector.selectedPortList.map<number>(port => port.locationId);
    if (this.desPortSelector.selectedPortList) this.transReqBody.desLocationList = this.desPortSelector.selectedPortList.map<number>(port => port.locationId);
    
    if (this.getTransFareSubs) this.getTransFareSubs.unsubscribe();
    if(page == 0) this.gridTransFareList = [];
    this.getTransFareSubs = this.fareService.getTransFare(this.transType, this.transReqBody).subscribe(
      resp =>{
        this.gridTransApi.hideOverlay();
        if (resp.result) {
          this.blockSize = resp.data.size;
          let transFares: RouteFareTrans[] = resp.data.dataLst;
          let gridFareList: GridTransRouteFare[] = this.gridTransFareList || [];
          this.infiniteInitialRowCount = resp.data.totalElems;

          for (let fare of transFares) {
            let gridFare: GridTransRouteFare = new GridTransRouteFare(fare);
            let line: Line = this.lines.find(l => l.lineCd == gridFare.lineCd);
            gridFare.line = line;
            gridFareList.push(gridFare);
          }
          this.gridTransFareList = gridFareList;

          if(page == 0) this.setTransFareList();

          if(callback) callback(resp);

        } else {
          this.alertService.error(resp.errorMsg);
        }
      }
    );

  }

  setTransFareList() {
    let params = this.gridTransParams;
      let dataSource = {
        rowCount: null,
        getRows: (params: IGetRowsParams) => {
          let page = this.transReqBody.curPage + 1;
          this.getTransFareList(page, (resp) => {
            let rowsThisPage = this.gridTransFareList.slice(params.startRow, params.endRow);
            let lastRow = this.gridTransFareList.length;
            if (params.endRow < resp.data.totalElems) {
              lastRow = params.endRow + 1;
              if (lastRow > resp.data.totalElems) lastRow = resp.data.totalElems;
            }
            params.successCallback(rowsThisPage, lastRow);
          });          
        }
      };
      
      this.gridTransApi.setDatasource(dataSource);
  }


  saveTransFareList() {
    this.gridTransApi.showLoadingOverlay();
    this.fareService.saveTransFare(this.transType, this.gridTransFareList).subscribe(
      resp => {
        this.gridTransApi.hideOverlay();
        if (resp.result) {
          this.getTransFareList(0);
        } else {
          this.alertService.error(resp.errorMsg);
        }
      }
    );
  }
  

  makeIncidFareList() {
    let locationList: Port[] = [];
    let itemList: CostItemModel[] = [];

    locationList = this.portSelector.selectedPortList;
    itemList = this.costItemSelector.selectedValues.map<CostItemModel>(item => item.value);
    
    let appendList: GridIncidRouteFare[] = [];
    locationList.forEach(
      location => {
        if (itemList && itemList.length > 0) {
          itemList.forEach(
            item => {
              let newOrgFare: GridIncidRouteFare = new GridIncidRouteFare();
              let newDesFare: GridIncidRouteFare = new GridIncidRouteFare();
              newOrgFare.init(location, this.transType, this.myCorp, item);
              newOrgFare.costTp = 0;
              newDesFare.init(location, this.transType, this.myCorp, item);
              newDesFare.costTp = 1;
              appendList.push(newOrgFare);
              appendList.push(newDesFare);
            }
          );
        } else {
          let newOrgFare: GridIncidRouteFare = new GridIncidRouteFare();
          let newDesFare: GridIncidRouteFare = new GridIncidRouteFare();
          newOrgFare.init(location, this.transType, this.myCorp);
          newOrgFare.costTp = 0;
          newDesFare.init(location, this.transType, this.myCorp);
          newDesFare.costTp = 1;
          appendList.push(newOrgFare);
          appendList.push(newDesFare);
        }
      }
    );

    if (appendList && appendList.length > 0) this.gridIncidFareList = this.gridIncidFareList.concat(appendList);
  }

  getIncidFareList() {
    this.gridIncidApi.showLoadingOverlay();

    let reqBody: IncidFareConditionModel = new IncidFareConditionModel();
    if (this.portSelector.selectedPortList) reqBody.locationList = this.portSelector.selectedPortList.map<number>(port => port.locationId);
    
    if (this.getTransIncidSubs) this.getTransIncidReqSubs.unsubscribe();
    

    this.gridIncidFareList = [];
    
    this.getTransIncidSubs = this.fareService.getIncidFare(this.transType, reqBody).subscribe(
      resp =>{
        this.gridIncidApi.hideOverlay();
        if (resp.result) {
          let incidFares: RouteFareIncid[] = resp.data;
          let gridFareList: GridIncidRouteFare[] = [];
          for (let fare of incidFares) {
            let gridFare: GridIncidRouteFare = new GridIncidRouteFare(fare);
            gridFareList.push(gridFare);
          }
          this.gridIncidFareList = gridFareList;
        } else {
          this.alertService.error(resp.errorMsg);
        }
      }
    );

    this.getIncidReqList(0);
  }

  getIncidReqList(page, callback?:(resp)=> void) {
    this.gridIncidReqApi.showLoadingOverlay();
    
    this.incidReqReqBody.curPage = page;
    if (this.portSelector.selectedPortList) this.incidReqReqBody.locationList = this.portSelector.selectedPortList.map<number>(port => port.locationId);

    if (this.getTransIncidReqSubs) this.getTransIncidReqSubs.unsubscribe();

    if(page == 0) {
      this.gridIncidFareReqList = [];
      this.gridIncidFareReqDtlList = [];
    }

    this.getTransIncidReqSubs = this.fareService.getIncidFareReq(this.transType, this.incidReqReqBody).subscribe(
      resp =>{
        this.gridIncidReqApi.hideOverlay();
        if (resp.result) {
          let dataLst = resp.data.dataLst;
          this.inciReqBlockSize = resp.data.size;

          for (let fare of dataLst) {
            this.gridIncidFareReqList.push(fare);
          }

          if(page == 0) this.setInciReqList();
          if(callback) callback(resp);

        } else {
          this.alertService.error(resp.errorMsg);
        }
      }
    );
  }

  setInciReqList() {
    let dataSource = {
      rowCount: null,
      getRows: (params: IGetRowsParams) => {
        let page = this.incidReqReqBody.curPage + 1;
        this.getIncidReqList(page, (resp) => {
          let rowsThisPage = this.gridIncidFareReqList.slice(params.startRow, params.endRow);
          let lastRow = this.gridIncidFareReqList.length;
          if (params.endRow < resp.data.totalElems) {
            lastRow = params.endRow + 1;
            if (lastRow > resp.data.totalElems) lastRow = resp.data.totalElems;
          }
          params.successCallback(rowsThisPage, lastRow);
        });          
      }
    };
    
    this.gridIncidReqApi.setDatasource(dataSource);
  }

  
  saveIncidFareList() {
    this.gridIncidApi.showLoadingOverlay();
    this.fareService.saveIncidFare(this.gridIncidFareList).subscribe(
      resp => {
        this.gridIncidApi.hideOverlay();
        if (resp.result) {
          this.getIncidFareList();
        } else {
          this.alertService.error(resp.errorMsg);
        }
      }
    );
  }

  onReqSelectionChanged() {
    let selectedRows = this.gridIncidReqApi.getSelectedRows();
    if (!selectedRows || selectedRows.length <= 0) return;
    this.gridIncidFareReqDtlList = selectedRows[0].fareIncidReqList;
  }


  applyIncidFareReqList() {
    this.gridIncidApi.showLoadingOverlay();

    let selectedRows = this.gridIncidReqApi.getSelectedRows();
    if (!selectedRows || selectedRows.length <= 0 || !selectedRows[0].fareIncidReqGrpId) return;
    this.fareService.applyIncidFareReq(selectedRows[0].fareIncidReqGrpId).subscribe(
      resp =>{
        this.gridIncidApi.hideOverlay();
        if (resp.result) {
          this.getIncidFareList();
        } else {
          this.alertService.error(resp.errorMsg);
        }
      }
    );
  }

}





// WEBPACK FOOTER //
// ./src/app/containers/fare/fare-management.ts